<template>
	<u-popup :show="show" round="15" :safeAreaInsetBottom="false" :closeable="true" mode="bottom" @close="show = false">
		<view class="login">
			<image src="/static/images/logo@2x.png" mode="widthFix"></image>
			<view class="login-info">
				<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
				<view class="login-info-text">
					我已阅读并同意<text>《鼎元科技用户服务协议》</text>及<text>《鼎元科技用户隐私政策》</text>
				</view>
			</view>
			<button class="login-btn" open-type="getPhoneNumber" @getphonenumber="getphonenumber">手机号快捷登录</button>
		</view>
	</u-popup>
</template>

<script>
	export default {
		name: "login",
		data() {
			return {
				show: false
			};
		},
		methods: {
			open() {
				this.show = true
			},
			close() {
				this.show = false
			},
			getphonenumber(e) {
				console.log(e)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 120rpx 48rpx 80rpx 48rpx;
		box-sizing: border-box;
		image {
			width: 400rpx;
			height: 96rpx;
		}
		.login-info {
			width: 100%;
			display: flex;
			align-items: flex-start;
			margin-top: 120rpx;
			image {
				width: 36rpx;
				height: 36rpx;
				flex-shrink: 0;
				margin-right: 14rpx;
			}
			.login-info-text {
				flex: 1;
				font-weight: 400;
				font-size: 24rpx;
				color: #555555;
				text {
					color: #2E68C4;
				}
			}
		}
		.login-btn {
			width: 100%;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #004096;
			border-radius: 44rpx;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			margin-top: 40rpx;
		}
	}
</style>